import { InternalProduct } from 'components/discovery/product/tile-parts/tile-parts-typing.js'
import { AnalyticsContext } from 'components/shared/analytics/analytics-types.js'

export type Ga4Item = Record<string, string | number>

function categoryFields(treePath: string[]): Record<string, string> {
  return treePath.reduce<Record<string, string>>((fields, category, index) => {
    const key = index === 0 ? 'item_category' : `item_category${index + 1}`
    fields[key] = category
    return fields
  }, {})
}

function isUsable(value: string | number | null | undefined): value is string | number {
  return value !== null && value !== undefined && value !== ''
}

export function productPrice(product: InternalProduct): number {
  const raw = [product.prices.saleNoFormat, product.prices.saleDisplay, product.prices.sale].find(isUsable)
  const numeric = typeof raw === 'number' ? raw : Number(raw)
  return Number.isFinite(numeric) ? numeric : 0
}

export function toGa4Item(product: InternalProduct, context: AnalyticsContext, quantity = 1): Ga4Item {
  return {
    item_id: product.code || String(product.id),
    item_name: product.name,
    item_brand: product.brandName,
    ...categoryFields(product.analyticsTreePath),
    ...(product.variant?.name ? { item_variant: product.variant.name } : {}),
    price: productPrice(product),
    quantity,
    ...(context.index !== undefined ? { index: context.index } : {}),
  }
}
